// export const apiDomain = 'http://main-core.test'
export const apiDomain = 'https://core.archotek.com'
export const Urls = {
    testUrl: apiDomain + '/api/test',
    userUrl : apiDomain + '/api/user',
    loginUrl: apiDomain + '/oauth/token',
    registerUrl: apiDomain + '/api/register',
    projectsUrl: apiDomain + '/api/projects',
    blogsUrl: apiDomain + '/api/blogs',
    categotyProjectsUrl: apiDomain + '/api/category/projects',
    categoriesUrl: apiDomain + '/api/categories/projects',
    categoryUrl: apiDomain + '/api/category',
    galleryUrl: apiDomain + '/api/gallery',
    similarUrl: apiDomain + '/api/projects/similar',
    contactsUrl: apiDomain + '/api/contacts'
}
export const allheaders = {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
export const getHeader = function(tokens){
    const headers = {
        'Accept': 'application/json',
        'Authorization' : 'Bearer ' + tokens.access_token
    }
    return headers
}

export const checkForDub = function(arr,data,key){
    let dub = false;
    if( key === 'slug'){
        for(var i = 0; i < arr.length; i++) {
            if(arr[i].slug === data.slug){
                dub =  true;
            }
        }
    }
    if(key === 'name'){
        for(var i = 0; i < arr.length; i++) {
            if(arr[i].name === data.name){
                dub =  true;
            }
        }
    }
    if(key === 'id'){
        for(var i = 0; i < arr.length; i++) {
            if(arr[i].id === data.id){
                dub =  true;
            }
        }
    }
    return dub;
}




// WEBPACK FOOTER //
// ./src/config.js